/**
 * Map `handleErrorResponse` throws (plain objects) to user-facing `Error` using domain resolvers.
 */

export function mapThrownPublicApiError(
	e: unknown,
	resolveMessage: (code: string | undefined, raw: string) => string,
): Error {
	if (e instanceof Error) {
		return e;
	}
	const o = e as { code?: string; message?: string; http_status?: number };
	const raw =
		typeof o.message === "string" && o.message.length > 0
			? o.message
			: typeof o.http_status === "number"
				? `HTTP ${o.http_status}`
				: "Request failed";
	const code = typeof o.code === "string" ? o.code : undefined;
	return new Error(resolveMessage(code, raw));
}
